import React from 'react'

const Blog = () => {
    return (
        <div>
            <div className="site-wrap" id="home-section">
                <div className="site-mobile-menu site-navbar-target mt-5">
                    <div className="site-mobile-menu-header">
                        <div className="site-mobile-menu-close mt-3">
                            <span className="icon-close2 js-menu-toggle" />
                        </div>
                    </div>
                    <div className="site-mobile-menu-body" />
                </div>
                <header className="site-navbar site-navbar-target mt-5" role="banner">
                    <div className="container">
                        <div className="row align-items-center position-relative">
                            <div className="col-3 ">
                                <div className="site-logo">
                                    <a href="index.html">
                                        <img
                                            style={{ width: 150 }}
                                            src="https://i.ibb.co/mGh4f8g/Premium-Car-Rentals-Limited-Logo-Design-1-removebg-preview.png"
                                            alt=""
                                        />
                                    </a>
                                </div>
                            </div>
                            <div className="col-9  text-right">
                                <span className="d-inline-block d-lg-none">
                                    <a
                                        href="#"
                                        className="text-white site-menu-toggle js-menu-toggle py-5 text-white"
                                    >
                                        <span className="icon-menu h3 text-white" />
                                    </a>
                                </span>
                                <nav
                                    className="site-navigation text-right ml-auto d-none d-lg-block"
                                    role="navigation"
                                >
                                    <ul className="site-menu main-menu js-clone-nav ml-auto ">
                                        <li className="active">
                                            <a href="index.html" className="nav-link">
                                                Home
                                            </a>
                                        </li>
                                        <li>
                                            <a href="about.html" className="nav-link">
                                                About
                                            </a>
                                        </li>
                                        <li>
                                            <a href="cars.html" className="nav-link">
                                                Our Fleet
                                            </a>
                                        </li>
                                        <li>
                                            <a href="services.html" className="nav-link">
                                                Our Services
                                            </a>
                                        </li>
                                        <li>
                                            <a href="contact.html" className="nav-link">
                                                Contact
                                            </a>
                                        </li>
                                        <button className="btn btn-primary text-white  p-0 m-0">
                                            <li style={{ listStyle: "none" }}>
                                                <a className="nav-link text-white">Login</a>
                                            </li>
                                        </button>
                                    </ul>
                                </nav>
                            </div>
                        </div>
                    </div>
                </header>
                <div className="ftco-blocks-cover-1">
                    <div
                        className="ftco-cover-1 overlay innerpage"
                        style={{
                            backgroundImage:
                                "url(https://pricelessrentalsusa.com/wp-content/uploads/2023/07/mt-1582-home-header-bg-1.jpg)"
                        }}
                    >
                        <div className="container">
                            <div className="row align-items-center justify-content-center">
                                <div className="col-lg-6 text-center">
                                    <h1>Car Articles</h1>
                                    <p>
                                        Stay informed with the latest news, tips, and expert insights on
                                        car rentals. Whether you're a frequent traveler or a first-time
                                        renter, our articles provide valuable information to help you make
                                        informed decisions and enjoy a seamless experience with your
                                        rental car
                                    </p>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="site-section bg-white">
                    <div className="container">
                        <div className="row justify-content-center text-center mb-5">
                            <div className="col-7 text-center mb-5">
                                <h2>Our Blog</h2>
                            </div>
                        </div>
                        <div className="row">
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="post-entry-1 h-100">
                                    <a href="single.html">
                                        <img src="images/post_1.jpg" alt="Image" className="img-fluid" />
                                    </a>
                                    <div className="post-entry-1-contents">
                                        <h2>
                                            <a href="single.html">
                                                The Ultimate Guide to Renting a Car: Tips for First-Timers
                                            </a>
                                        </h2>
                                        <p>
                                            Renting a car for the first time can be both exciting and
                                            overwhelming. With so many options and factors to consider, it’s
                                            important to know what to look for to make the process smooth
                                            and stress-free. In this guide, we’ll walk you through the
                                            essential steps to take when renting a car, from choosing the
                                            right vehicle to understanding rental policies and maximizing
                                            your experience.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="post-entry-1 h-100">
                                    <a href="single.html">
                                        <img src="images/img_2.jpg" alt="Image" className="img-fluid" />
                                    </a>
                                    <div className="post-entry-1-contents">
                                        <h2>
                                            <a href="single.html">
                                                Luxury Car Rentals: Experience Comfort and Class on the Road
                                            </a>
                                        </h2>
                                        <p>
                                            Why settle for ordinary when you can travel in style? Luxury car
                                            rentals offer more than just transportation; they provide an
                                            elevated experience that makes every journey unforgettable.
                                            Whether it’s for a special event, a weekend getaway, or simply
                                            indulging in comfort, renting a premium car brings
                                            sophistication and excitement to your travels. Discover why
                                            opting for a luxury vehicle could be the perfect choice for your
                                            next trip.
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-lg-4 col-md-6 mb-4">
                                <div className="post-entry-1 h-100">
                                    <a href="single.html">
                                        <img src="images/img_3.jpg" alt="Image" className="img-fluid" />
                                    </a>
                                    <div className="post-entry-1-contents">
                                        <h2>
                                            <a href="single.html">
                                                The Benefits of Renting vs. Owning a Car: What’s Right for
                                                You?
                                            </a>
                                        </h2>
                                        <p>
                                            Owning a car has its perks, but is it always the best option? In
                                            this blog, we’ll explore the key advantages of renting a car
                                            instead of buying one. From cost savings and flexibility to
                                            accessing a variety of vehicles, renting can be a smart choice
                                            for those who value convenience and variety. Read on to see how
                                            rental services can fit into your lifestyle and driving needs.
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="container site-section mb-5">
                    <div className="row justify-content-center text-center">
                        <div className="col-7 text-center mb-5">
                            <h2>How it works</h2>
                            <p>
                                Our user-friendly platform ensures a quick and easy reservation
                                process.
                            </p>
                        </div>
                    </div>
                    <div className="how-it-works d-flex">
                        <div className="step">
                            <span className="number">
                                <span>01</span>
                            </span>
                            <span className="caption">Time &amp; Place</span>
                        </div>
                        <div className="step">
                            <span className="number">
                                <span>02</span>
                            </span>
                            <span className="caption">Car</span>
                        </div>
                        <div className="step">
                            <span className="number">
                                <span>03</span>
                            </span>
                            <span className="caption">Details</span>
                        </div>
                        <div className="step">
                            <span className="number">
                                <span>04</span>
                            </span>
                            <span className="caption">Checkout</span>
                        </div>
                        <div className="step">
                            <span className="number">
                                <span>05</span>
                            </span>
                            <span className="caption">Done</span>
                        </div>
                    </div>
                </div>
             
            </div>

        </div>
    )
}

export default Blog
